<template>
  <el-container class="index_content">
    <el-header>
      <index-header></index-header>
    </el-header>
    <el-container class="mainContent">
      <el-aside width="295px">
        <div class="timeZoneAside">
          {{$t('index.timeZone')}} (UTC{{utils.globetime()}})
        </div>
        <div class="userAside">
          <p class="font_24_bold">{{$t('index.profile')}}</p>
          <!-- <p>{{$t('header.message')}}</p> -->
          <div class="contactlist">
            <div class="flex_start informaInfo">
              <img src="../assets/icon_phone.svg"/>
              <div class="lineInfo">
                <span class="font_14 color_grey">{{$t('index.phone')}}</span>
                <p class="font_18_reg color_black">+{{data.country_code}} {{data.mobile}}</p>
              </div>
            </div>
            <div class="flex_start informaInfo">
              <img src="../assets/globe.svg"/>
              <div class="lineInfo">
                <span class="font_14 color_grey">{{$t('index.location')}}</span>
                <p class="font_18_reg color_black"
                   v-html="data.user_city&&data.user_country?data.user_city+', '+data.user_country:'-'"></p>
              </div>
            </div>
            <div class="flex_start informaInfo">
              <img src="../assets/icon_mail.svg"/>
              <div class="lineInfo">
                <span class="font_14 color_grey">{{$t('index.email')}}</span>
                <p class="font_18_reg color_black" v-html="data.email?data.email:'-'"></p>
              </div>
            </div>
            <div class="flex_start informaInfo">
              <img src="../assets/icon_gift.svg"/>
              <div class="lineInfo">
                <span class="font_14 color_grey">{{$t('index.referrer')}}</span>
                <p class="font_18_reg color_black" v-html="data.referer?data.referer:'-'"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="userAside">
          <p class="font_24_bold">{{$t('index.creditBalance')}}</p>
          <div class="contactlist">
            <div class="flex_center informaInfo">
              <img src="../assets/money.svg"/>
              <div class="lineInfo">
                <p class="font_36_reg color_black">{{balanceData.balance_valid}}</p>
              </div>
            </div>
            <el-button type="primary" @click="toRecharge">{{$t('index.topUp')}}</el-button>
            <el-button class="huo" @click="toPayList">{{$t('index.viewDetails')}}</el-button>
          </div>
        </div>
        <div class="userAside">
          <p class="font_24_bold">{{$t('index.myChild')}}</p>
          <div class="contactlist">
            <div class="flex_start childInfo" v-for="(item,i) in childData" :key='i'>
              <img :src="item.avatar"/>
              <div class="lineInfo">
                <span class="font_18_reg ellipsis" :title="item.nickname">{{item.nickname}}</span>
                <div class="flex_start birthInfo">
                  <img src="../assets/cake.svg"/>
                  <div class="lineInfo">
                    <span class="font_14 color_grey">{{$t('index.ofBirth')}}</span>
                    <p>{{item.birth_date}}</p>
                  </div>
                </div>
                <!-- <p class="font_18_reg color_black">+1 3948839485</p> -->
              </div>
            </div>
            <el-button type="primary" @click="editChild">{{$t('index.editChild')}}</el-button>
          </div>
        </div>
      </el-aside>
      <el-main>
        <div class="select-part flex_between">
          <el-select v-model="searchStudentSn" @change="search" filterable collapse-tags
                     :placeholder="$t('searchTabBar.selectChild')">
            <el-option value="">{{$t('searchTabBar.all')}}</el-option>
            <el-option v-for="item in childData"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.student_sn"
            >{{item.nickname}}
            </el-option>
          </el-select>
          <p class="font_16 color_grey">{{$t('searchTabBar.Showing')}} {{now_status}}</p>
        </div>
        <el-tabs v-model="activeTitle" type="card" @tab-click="handleClick">
          <el-tab-pane :label="$t('searchTabBar.scheduled')" name="schedule" class="schedule_">
            <my-scheduled :dataschedule="scheduleData" @sickSuc="RepeatSchedule"></my-scheduled>
            <el-pagination
              v-if="total>0"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pagesize"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane :label="$t('searchTabBar.course')" name="course" class="course_">
            <my-course :datacourse="courseData"></my-course>
          </el-tab-pane>
          <el-tab-pane :label="$t('searchTabBar.completedLesson')" name="lesson">
            <past-lesson :datalesson="lessonData"></past-lesson>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
    <el-footer>
      <index-footer></index-footer>
    </el-footer>
  </el-container>

</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from './views/header'
  import IndexFooter from './views/footer'
  import MyScheduled from './views/scheduled'
  import MyCourse from './views/course'
  import PastLesson from './views/lesson'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse
    },

    data () {
      return {
        data: [],
        childData: [],
        interval: null,
        activeTitle: 'schedule', /* calendar */
        timeRang: Array.apply(null, Array(2)).map(() => ''), // 日期范围
        searchStudentSn: '',
        scheduleData: [],
        courseData: [],
        balanceData: {},
        lessonData: [],
        now_status: '',
        pageNum: 1,
        total: 0,
        pagesize: 10
      }
    },
    created () {
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      // 用户信息
      this.getUser()
      // 账户信息
      this.getBalance()
      // 孩子信息
      this.getChild()
      // 搜索全部正在上和还没上的课
      this.search()
      if (this.$route.query.type == 1) {
        this.activeTitle = 'course'
      } else {
        this.activeTitle = 'schedule'
      }
    },
    methods: {
      handleClick (tab, event) {
        console.log(tab, event)
        this.$router.push(this.$route.path)
        if (tab.name == 'course') {
          this.getCourse()
        } else if (tab.name == 'schedule') {
          this.getschedule()
        } else if (tab.name == 'lesson') {
          this.getLesson()
        }
      },
      toRecharge () {
        this.$router.push({path: '/recharge'})
      },
      getUser () {
        this.$http.get('/api/user/profile').then((res) => {
          if (res.data.code == 200) {
            console.log(res)
            this.data = res.data.data
            setStore(keys.userProfile, res.data.data)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getBalance () {
        this.$http.get('/api/accounts?model=lessons').then((res) => {
          if (res.data.code == 200) {
            console.log('账户信息',res)
            this.balanceData = res.data.data
            setStore(keys.userBalance,res.data.data)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getChild () {
        this.$http.get('/api/students').then((res) => {
          if (res.data.code == 200) {
            console.log(res)


            this.childData = res.data.data



          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      search () {
        setStore(keys.searchFilter, this.searchStudentSn)
        // 我的时间表
        this.getschedule()
        this.getCourse()
        this.getLesson()
      },
      editChild () {
        this.$router.push({path: '/allChild'})
      },
      getschedule () {
        console.log('=============================this')
        // console.log(this)
        console.log(navigator.language)
        let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
        this.$http.get('/api/userSchedukeForStudent?type=1001&student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone() + '&pagesize=' + this.pagesize + '&page=' + this.pageNum, {headers: {lan: _lan}}).then((res) => {
          if (res.data.code == 200) {
            this.scheduleData = res.data.data
            this.now_status = res.data.now_status
            this.total = res.data.total
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getCourse () {
        this.$http.post('/api/myCourse?student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            console.log(res)

            this.courseData = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getLesson () {
        this.$http.get('/api/getCompletedLessonPC?student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            this.lessonData = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      toPayList () {
        this.$router.push({path: '/payHistory'})
      },
      RepeatSchedule (data) {
        if (data) {
          this.getschedule()
        }
      },
      handleCurrentChange (val) {
        this.pageNum = val
        this.getschedule()
      }
    },
  }
</script>
<style lang="less" scoped>
  .index_content {
    position: relative;

    .el-header {
      height: 88px !important;
      background: rgba(53, 54, 67, 0.90);
      width: 100%;
      padding: 0;
    }

    .el-main {
      overflow: inherit;
    }

    .mainContent {
      width: 1200px;
      margin: 25px auto 254px;
      z-index: 22;

      .el-aside {
        h3 {
          font-size: 24px;
          font-family: Sofia Pro-Bold;
          font-weight: 700;
          color: #353643;
          letter-spacing: 0px;
          margin-bottom: 20px;
        }

        .timeZoneAside {
          height: 44px;
          line-height: 44px;
          text-align: center;
          background: #353643;
          border-radius: 6px;
          color: #ffffff;
          font-family: Sofia Pro-Regular;
          font-size: 14px;
          margin-bottom: 10px;
        }

        .userAside {
          padding: 30px 28px;
          background: #ffffff;
          border-radius: 5px;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
          margin-bottom: 20px;

          > img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
          }

          .contactlist {
            display: flex;
            flex-direction: column;

            img {
              width: 24px;
              height: 24px;
            }

            .lineInfo {
              margin-left: 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-around;

              > p {
                width: 100%;
                word-break: break-all;
              }
            }

            .informaInfo {
              margin-top: 25px;
            }

            .childInfo {
              padding: 30px 0;
              border-bottom: 3px solid #F8F8F8;

              img {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                margin-right: 20px;
              }

              .birthInfo {
                margin-top: 20px;

                img {
                  width: 18px;
                  height: 18px;
                  border-radius: inherit;
                  margin-right: 0px;
                }
              }
            }
          }

          .ellipsis {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
          }

          .monthInfo {
            height: 90px;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            margin-top: 20px;
            border-top: 1px solid #f8f8f8;
          }

          .huo {
            font-size: 16px;
            font-family: Sofia Pro-Bold;
            font-weight: 700;
            text-decoration: underline;
            text-align: LEFT;
            color: #ff6440;
            cursor: pointer;
            display: contents;
          }

          button {
            width: 160px;
            height: 40px;
            background: #ff6440;
            border-radius: 4px;
            border: 1px solid #ff6440;
            margin-top: 20px;
            margin-bottom: 15px;
            color: #fff;
            font-size: 16px;
            font-family: Sofia Pro-Bold;
            box-shadow: 0px 1px 6px 1px rgba(81, 124, 255, 0.20), 0px 1px 6px 1px rgba(81, 124, 255, 0.20);
          }

          .borderBtn {
            width: auto;
            height: 40px;
            background: #ffffff;
            border: 2px solid #ff6440;
            border-radius: 7px;
            font-size: 14px;
            font-family: Sofia Pro-Bold;
            font-weight: 700;
            color: #ff6440;
            margin: 0 20px;

            &:hover {
              background: #ffffff;
              border: 2px solid #ff6440;
              font-size: 14px;
              font-family: Sofia Pro-Bold;
              font-weight: 700;
              color: #ff6440;
            }
          }
        }
      }

      .select-part {
        // background: rgba(235, 233, 241, 0.5);
        border-radius: 5px;
        margin: 0 32px 23px 32px;

        .el-select {
          width: 343px;
          height: 40px;
          background: none;
          border-bottom: 1px solid #6B6B6B;
          color: #353643;

          /deep/ .el-input {
            height: 40px;

            .el-input__inner {
              width: 330px;
              height: 100%;
              background: none;
              border: none;
              color: #353643;
              font-family: Sofia Pro-Regular;
            }

            .el-input__suffix {
              right: 15px;
            }

            .el-select__caret {
              color: #6e6b7b;
            }
          }
        }
      }

      .schedule_ {
        .form-search {
          .clearBtn {
            margin-left: 40px;
            color: #ff6440;
            text-decoration: underline;
          }
        }

      }
    }

    .el-footer {
      width: 100%;
      height: inherit !important;
      padding: 0;
      position: absolute;
      bottom: 0;
    }
  }

  // tab切换
  /deep/ .el-tabs--card {
    .el-tabs__header {
      border: none;
      margin: 0;
      // .el-tabs__nav-wrap{
      // margin-bottom:0;
      // }
      .el-tabs__nav {
        border: none;
        border-radius: 0;

        .el-tabs__item {
          background: rgba(248, 248, 248, 0.80);
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #a5a5a5;
          border-bottom: none;
          font-size: 18px;
          color: #a5a5a5;
          margin-left: 4px;
          margin-right: 16px;
          font-family: Sofia Pro-Regular;

          &.is-active {
            border: 1px solid #ffd1c6;
            background: #ffd1c6;
            color: #ff6440;
            font-family: Sofia Pro-Bold;
            box-shadow: 4px 4px 5px 0px rgba(255, 100, 64, 0.15);
          }
        }
      }
    }

    .el-tabs__content {
      background: #fff;
      border: 1px solid #ffd1c6;
      border-radius: 6px;

      .el-tab-pane {
        margin: 20px 13px 55px;
      }
    }
  }

  // 设置下拉框
  /deep/ .el-popper {
    margin: 0;
  }

  /deep/ .el-dropdown-menu {
    width: 200px;
    padding: 6px 0;
    margin: 0;
    font-family: Sofia Pro-Regular;
  }

  /deep/ .el-dropdown-menu__item {
    width: 160px;
    background: #fff;
    color: #353643;
    font-size: 16px;
    line-height: 40px;
    padding: 0 20px;
  }

  /deep/ .popper__arrow {
    display: none;
  }

  /deep/ .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background: rgba(255, 100, 64, 0.30);
    font-size: 16px;
    font-family: Sofia Pro-Bold;
    font-weight: 700;
    color: #ff6440;
    letter-spacing: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue